// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"428":"95a24d6e","565":"07f56d67"}[chunkId] + ".css";
};